import * as RequerimentoOperations from './operations';
import RequerimentoReducer from './reducer';

export { RequerimentoOperations };

export default RequerimentoReducer;
